import axios from 'axios';
import store from '@/store';
import router from '../router';
import { showToast } from '@/helpers/toast-handler';

const authApi = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
});

authApi.defaults.headers.common['Content-Type'] = 'application/json';

authApi.interceptors.request.use(
    (config) => {
        const token = store.state.auth.token;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

let retries = 0;
let unauthenticatedFlag = false;
// add response interceptors to handle response data and errors
authApi.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Check if the unauthenticatedFlag is set
        if (unauthenticatedFlag) {
            // If the flag is set, don't proceed with the request
            return Promise.reject(error);
        }

        if (retries < 2) {
            // Retry the request up to 2 times
            retries++;
            return authApi(error.config);
        } else {
            // Check for authentication error or token expiration
            if (error.response) {
                if (error.response.data.message.includes('Unauthenticated')) {
                    // Set the unauthenticatedFlag to true
                    unauthenticatedFlag = true;
                    // console.log(error.response);
                    showToast({}, 'User Session has expired, Login to continue..');
                    setTimeout(async () => {
                        await store.dispatch('auth/logout');
                        return router.push('/login');
                    }, 3000);
                }
            }
            return Promise.reject(error.response);
        }
    }
);

// Function to reset unauthenticatedFlag when a user logs in
export function resetUnauthenticatedFlag() {
    unauthenticatedFlag = false;
}
// Add CORS headers
// commented for now because its adding extra layers to too many requests
// authApi.interceptors.request.use(
//     (config) => {
//         config.headers['Accept'] = '*/*';
//         config.headers['Access-Control-Allow-Origin'] = '*/*';
//         config.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS';
//         config.headers['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept, Authorization';
//         // console.log(config);
//         return config;
//     },
//     (error) => {
//         return Promise.reject(error);
//     }
// );

export default authApi;
